import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header/Header.vue'
import Sidebar from './Sidebar/Sidebar.vue'
import Switch from './Switch.vue'

export {
	Aside,
	Breadcrumb,
	Callout,
	Footer,
	Header,
	Sidebar,
	Switch
}



// WEBPACK FOOTER //
// ./src/components/index.js